var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    stroke: "#FFB43A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5898 27.4979C15.2486 23.3104 16.8161 18.5242 21.2123 17.1079C23.5248 16.3617 26.0773 16.8017 27.9998 18.2479C29.8186 16.8417 32.4648 16.3667 34.7748 17.1079C39.1711 18.5242 40.7486 23.3104 39.4086 27.4979C37.3211 34.1354 27.9998 39.2479 27.9998 39.2479C27.9998 39.2479 18.7473 34.2129 16.5898 27.4979Z",
    stroke: "#FFB43A",
    fill: "#FFB43A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33 21.375C34.3375 21.8075 35.2825 23.0013 35.3962 24.4025",
    stroke: "#FFB43A",
    fill: "#FFB43A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikefill);
export default __webpack_public_path__ + "static/media/likefill.f7205e0d43311df62d84ba9faad4209c.svg";
export { ForwardRef as ReactComponent };